import React from 'react'
import { useAppSelector } from 'src/store/index'
import Backdrop from '@mui/material/Backdrop'
import CircularProgress from '@mui/material/CircularProgress'

const RootLoadingMask = () => {
  const { open } = useAppSelector((state) => state.loadingMaskSlice)
  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1e3 }}
      open={open}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  )
}

export default RootLoadingMask
